const normalizeSelections = (value) =>
  (Array.isArray(value) ? value : [value].filter(Boolean)).map(String);

const selectionsMatch = (left, right) => {
  const normalizedLeft = normalizeSelections(left).sort();
  const normalizedRight = normalizeSelections(right).sort();
  return JSON.stringify(normalizedLeft) === JSON.stringify(normalizedRight);
};

const normalizeDetail = (detail) =>
  detail.map((answer) => {
    const selected = normalizeSelections(answer.selected);
    const correct = normalizeSelections(answer.correct);
    return {
      ...answer,
      questionId: Number(answer.questionId),
      selected,
      correct,
      isCorrect: selectionsMatch(selected, correct),
    };
  });

export const buildTrainingResultDetail = ({
  questions = [],
  savedAnswers = [],
  savedResultDetail = [],
}) => {
  // Completed attempts store the exact questions and answer key used when the
  // user submitted. Prefer that immutable snapshot when a module is edited.
  if (Array.isArray(savedResultDetail) && savedResultDetail.length > 0) {
    return normalizeDetail(savedResultDetail);
  }

  const selectedByQuestion = new Map(
    savedAnswers.map((answer) => [
      Number(answer.questionId),
      normalizeSelections(answer.selected),
    ]),
  );

  return normalizeDetail(
    questions.map((question) => ({
      questionId: Number(question.id),
      question: question.question,
      options: question.options || [],
      selected: selectedByQuestion.get(Number(question.id)) || [],
      correct: question.correct || [],
    })),
  );
};

